module.exports = __webpack_public_path__ + "static/media/0323_IMG_LE_FROMAGER_KIOSQUE.a7b49a1a.png";